/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminUpdateVideoOptions, AdminUpdateVideoResponses } from '../../models/AdminUpdateVideo'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Update Video
 * {@link /admin/video/:video_id}
 */
export function adminUpdateVideo<ThrowOnError extends boolean = true>(options: Options<AdminUpdateVideoOptions, ThrowOnError>): Promise<UnwrappedResult<AdminUpdateVideoResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'PATCH', url: '/admin/video/{video_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminUpdateVideoResponses, ThrowOnError>>
}
